
import React from 'react';
import styles from './Header.module.css';
import { FiMenu, FiLogOut } from 'react-icons/fi';

const Header = ({ onLogout, onMenuClick }) => {
  const handleMenuClick = () => {
    window.dispatchEvent(new Event('toggleSidebar'));
    if (onMenuClick) onMenuClick();
  };

  return (
    <header className={styles.header}>
      <div
        className={styles.leftSection}
        onClick={() => window.location.reload()}
        aria-label="Home"
      >
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 1000"
        className={styles.logo}
        aria-label="Logo"
      >
        <defs>
          <style>{`.cls-1{fill:#050e28;}`}</style>
        </defs>
        <g>
          <path
            className="cls-1"
            d="M327.15,663.58h-39.34v-52.56h39.34v9.61h-29.51v12.09h28.46v9.24h-28.46v11.86h29.51v9.76Z"
          />
          <path
            className="cls-1"
            d="M372.57,611.09v52.48h-8.56l-.6-5.11c-2.85,4.43-7.43,5.93-11.94,5.93-10.89,0-19.07-7.21-19.07-19.37,0-12.76,8.03-19.37,18.85-19.37,3.9,0,9.99,2.1,12.16,5.93v-20.5h9.16ZM341.56,645.03c0,6.46,4.66,10.89,10.51,10.89s10.74-4.2,10.74-10.89-4.96-10.81-10.74-10.81-10.51,4.13-10.51,10.81Z"
          />
          <path
            className="cls-1"
            d="M389.09,626.56v19.37c0,5.63,3.08,9.91,8.93,9.91s9.46-4.73,9.46-10.36v-18.92h9.08v37.09h-8.18l-.6-5.03c-3.83,3.75-7.36,5.56-12.54,5.56-8.86,0-15.32-6.68-15.32-18.17v-19.45h9.16Z"
          />
          <path
            className="cls-1"
            d="M471.69,656.97c-5.41,5.33-12.39,7.81-19.97,7.81-19.52,0-27.78-13.44-27.86-27.1-.08-13.74,8.86-27.71,27.86-27.71,7.13,0,13.89,2.7,19.3,8.03l-6.61,6.38c-3.45-3.38-8.11-4.96-12.69-4.96-12.69,0-18.17,9.46-18.1,18.25.08,8.71,5.11,17.79,18.10,17.79,4.58,0,9.76-1.88,13.21-5.33l6.76,6.83Z"
          />
          <path
            className="cls-1"
            d="M504.35,626.56h8.78v37.02h-8.63l-.45-5.41c-2.10,4.35-7.88,6.46-12.01,6.53-10.96.07-19.07-6.68-19.07-19.67s8.48-19.45,19.30-19.37c4.96,0,9.69,2.33,11.79,6.01l.30-5.11ZM482.12,645.03c0,7.06,4.88,11.26,10.96,11.26,14.42,0,14.42-22.45,0-22.45-6.08,0-10.96,4.13-10.96,11.19Z"
          />
          <path
            className="cls-1"
            d="M520.86,679.04v-52.48h8.56l.60,5.11c2.85-4.13,7.81-5.93,12.01-5.93,11.41,0,19.00,8.48,19.00,19.37s-6.83,19.37-18.70,19.37c-3.90,0-9.69-1.20-12.31-5.26v19.82h-9.16ZM551.87,645.11c0-5.78-3.90-10.51-10.51-10.51s-10.51,4.73-10.51,10.51,4.28,10.51,10.51,10.51,10.51-4.73,10.51-10.51Z"
          />
          <path
            className="cls-1"
            d="M580.71,616.12v10.51h10.21v7.88h-10.29v15.99c0,3.53,1.95,5.26,4.81,5.26,1.43,0,3.08-.45,4.43-1.13l2.55,7.81c-2.63,1.05-4.81,1.50-7.58,1.58-8.03.30-13.29-4.28-13.29-13.52v-15.99h-6.91v-7.88h6.91v-9.54l9.16-.98Z"
          />
          <path
            className="cls-1"
            d="M607.14,626.56v19.37c0,5.63,3.08,9.91,8.93,9.91s9.46-4.73,9.46-10.36v-18.92h9.08v37.09h-8.18l-.60-5.03c-3.83,3.75-7.36,5.56-12.54,5.56-8.86,0-15.32-6.68-15.32-18.17v-19.45h9.16Z"
          />
          <path
            className="cls-1"
            d="M651.21,626.56l.68,4.28c2.85-4.58,6.68-5.26,10.44-5.26s7.51,1.50,9.54,3.53l-4.13,7.96c-1.88-1.58-3.60-2.40-6.61-2.40-4.81,0-9.24,2.55-9.24,9.39v19.52h-9.16v-37.02h8.48Z"
          />
          <path
            className="cls-1"
            d="M683.12,648.34c.60,4.58,4.58,7.88,11.04,7.88,3.38,0,7.81-1.28,9.91-3.45l5.86,5.78c-3.90,4.05-10.29,6.01-15.92,6.01-12.76,0-20.35-7.88-20.35-19.75s7.66-19.37,19.67-19.37,20.12,7.66,18.70,22.90h-28.91ZM703.24,640.75c-.60-4.81-4.35-7.21-9.61-7.21-4.96,0-9.01,2.40-10.36,7.21h19.97Z"
          />
        </g>
        <path
          d="M482.60,321.42c15.89-1.00,33.00-0.40,48.71,1.98,80.26,12.16,144.11,69.42,195.82,127.88-48.16,54.38-107.19,109.18-180.73,124.51-28.66,5.97-61.18,6.21-89.92,0.59-73.95-14.47-136.17-70.16-183.59-125.60,54.66-60.71,123.54-123.92,209.72-129.36ZM566.29,466.22c-8.25,37.35-44.97,61.68-82.74,52.70-45.89-10.91-66.11-67.59-38.37-105.79,23.98-33.02,72.44-37.78,101.79-8.72,2.54,2.52,5.88,8.30,7.93,10.02,2.12,1.77,9.07-1.09,11.74-2.05,3.38-1.20,19.86-9.04,19.56-12.66-30.91-54.44-106.91-65.83-153.54-23.97-77.34,69.43-14.78,198.39,88.62,177.00,50.92-10.53,85.64-60.61,79.53-112.08h21.41c1.86,30.50-5.37,61.65-24.16,85.97l1.02,0.33c33.72-20.77,64.02-46.55,91.54-74.89l0.34-1.74c-21.58-22.07-44.24-43.27-69.76-60.77-14.24,29.65-44.85,50.60-78.42,48.71-9.85-27.23-41.50-39.36-66.72-23.97-26.23,16.01-28.15,53.83-4.73,73.32,24.74,20.60,62.08,8.49,71.48-21.42h23.48ZM406.78,371.63c-0.79-0.70-15.07,8.44-16.93,9.65-30.14,19.51-57.53,43.72-82.47,69.41,26.86,29.95,58.73,55.09,92.85,76.29,0.85,0.28,1.39-0.17,1.02-1.02-0.68-1.57-4.74-6.18-6.08-8.43-28.11-47.19-22.77-103.65,11.61-145.90Z"
        />
      </svg>
      </div>

      {/* hamburger on right (mobile only) */}
      <button
        className={styles.menuBtn}
        onClick={handleMenuClick}
        aria-label="Toggle menu"
      >
        <FiMenu size={24} />
      </button>

      {/* logout on right (desktop only) */}
      <button className={styles.logoutDesktop} onClick={onLogout}>
        <FiLogOut size={18} style={{ marginRight: 8 }} />
        Uitloggen
      </button>
    </header>
  );
};

export default Header;
